import React, { useState } from "react";
import {
  Box,
  Typography,
  Button,
  Paper,
  Collapse,
  Divider,
  IconButton,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import StatusChip from "./StatusChip";

const DeviceCard = ({ item, onApprove, onUpdate, updateDisabled }) => {
  const [expanded, setExpanded] = useState(false);

  const hasOverride = item.chariaga && item.chariagaData;

  const rows = [
    { label: "מס' סיריאלי", value: item.SERNUM },
    { label: 'מק"ט', value: item.PARTNAME },
    { label: "תיאור פריט", value: item.PARTDES },
    { label: "מספר לקוח", value: hasOverride ? item.chariagaData.accName : item.CUSTNAME },
    { label: "שם לקוח", value: hasOverride ? item.chariagaData.accDes : item.CDES },
    { label: "אתר", value: hasOverride ? item.chariagaData.siteCodeDes : item.DCODEDES },
    { label: "מספר אתר", value: hasOverride ? item.chariagaData.siteCode : item.DCODE },
    { label: "זיהוי לקוח", value: item.ELDN_CUSTSERNUM },
  ];

  const excRows = [];

  const borderColor = item.approved
    ? "#4caf50"
    : item.chariaga
    ? "#e65100"
    : "transparent";
  const bgColor = item.approved
    ? "#f1fdf1"
    : item.chariaga
    ? "#fff8f0"
    : "#fff";

  return (
    <Paper
      elevation={2}
      sx={{
        borderRadius: 3,
        overflow: "hidden",
        border: `2px solid ${borderColor}`,
        transition: "border-color 0.3s, background-color 0.3s",
        bgcolor: bgColor,
        direction: "ltr",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          px: 2,
          py: 1.5,
          cursor: "pointer",
          userSelect: "none",
        }}
        onClick={() => setExpanded((p) => !p)}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <StatusChip item={item} />
          <Box>
            <Typography
              sx={{ fontWeight: 700, fontSize: "0.95rem", lineHeight: 1.2 }}
            >
              {item.SERNUM}
            </Typography>
            <Typography sx={{ fontSize: "0.8rem", color: "#666" }}>
              {item.PARTNAME}
            </Typography>
          </Box>
        </Box>
        <IconButton
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            setExpanded((p) => !p);
          }}
        >
          {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
      </Box>

      <Collapse in={expanded}>
        <Divider />
        <Box
          sx={{
            px: 2,
            py: 1.5,
            display: "flex",
            flexDirection: "column",
            gap: 1,
          }}
        >
          {[...rows, ...excRows].map(({ label, value }) => (
            <Box
              key={label}
              sx={{ display: "flex", justifyContent: "space-between", gap: 1 }}
            >
              <Typography
                sx={{
                  fontSize: "0.82rem",
                  color: "#666",
                  whiteSpace: "nowrap",
                }}
              >
                {label}
              </Typography>
              <Typography
                sx={{
                  fontSize: "0.82rem",
                  fontWeight: 600,
                  textAlign: "left",
                  wordBreak: "break-word",
                }}
              >
                {value || ""}
              </Typography>
            </Box>
          ))}
        </Box>

        <Divider />

        <Box sx={{ display: "flex", gap: 1.5, px: 2, py: 1.5 }}>
          <Button
            variant="contained"
            size="small"
            disabled={item.approved}
            onClick={(e) => {
              e.stopPropagation();
              onApprove(item.id);
            }}
            sx={{
              flex: 1,
              bgcolor: item.approved ? "#4caf50" : "#0563B0",
              "&:hover": { bgcolor: item.approved ? "#4caf50" : "#044a8a" },
              "&.Mui-disabled": { bgcolor: "#4caf50", color: "#fff" },
              fontWeight: 600,
              borderRadius: 2,
            }}
          >
            {item.approved ? "✓ אושר" : "אישור"}
          </Button>
          <Button
            variant="outlined"
            size="small"
            disabled={updateDisabled}
            onClick={(e) => {
              e.stopPropagation();
              onUpdate(item.id);
            }}
            sx={{
              flex: 1,
              borderColor: item.chariaga ? "#e65100" : "#0563B0",
              color: item.chariaga ? "#e65100" : "#0563B0",
              fontWeight: 600,
              borderRadius: 2,
              "&.Mui-disabled": { opacity: 0.5 },
            }}
          >
            {item.chariaga ? "⚠ עדכן חריגה" : "עדכון"}
          </Button>
        </Box>
      </Collapse>
    </Paper>
  );
};

export default DeviceCard;
